<template>
  <section class="content-plans">
    <div class="content-plans-itens">
      <Breadcrumb :links="links"/>
      <div class="content-plans-itens-body">
        <div class="row">
          <div class="col-12 col-sm-6 col-lg-6 col-xl-4 col-xl-3">
            <router-link tag="a" :to="{name: 'RegisterMeditation'}" class="content--card-register" style="min-height: 200px">
              <img class="img-fluid" src="@/assets/img/image-plus.png" alt="image plus" title="image plus"/>
            </router-link>
          </div>
          <div class="col-12 col-sm-6 col-lg-6 col-xl-4 col-xl-3" v-for="meditation in meditations.data" :key="meditation.id">
            <CardMeditation :meditation="meditation"/>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Breadcrumb from '@/components/breadcrumb/Index';
import CardMeditation from '@/views/Meditation/components/CardMeditation';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      links: [
      {
          name: 'Meditação',
          routerName: 'Meditation'
        },
        {
          name: 'Listar Meditações',
          routerName: 'ListMeditations'
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      meditations: 'Meditation/meditations'
    })
  },
  components: {
    Breadcrumb,
    CardMeditation
  },
  methods: {
    ...mapActions('Meditation', ['consultMeditations'])
  },
  mounted() {
    this.consultMeditations();
  }
}
</script>

<style lang="scss">
</style>
